export default "__VITE_ASSET__Bu77Vvpp__"